/**
 * The contracts register ("Contracte" in the dashboard): its counters, its
 * short status labels and how its filters become a query. Pure, so tested.
 */

/** The counters on top of the page, in the order they are read. Each is a filter. */
export const REGISTER_BUCKETS = [
  { key: "waiting_participant", label: "Așteaptă participantul", tone: "warn" },
  { key: "waiting_fped", label: "Așteaptă FPED", tone: "warn" },
  { key: "completed", label: "Semnate complet", tone: "ok" },
  { key: "rejected", label: "Refuzate", tone: "bad" },
  { key: "closed", label: "Netrimise sau anulate", tone: "neutral" },
];

/** Short labels, for table cells. The drawer keeps the long ones. */
export const SHORT_STATUS = {
  sending: { label: "Se trimite", tone: "neutral" },
  send_failed: { label: "Netrimis", tone: "bad" },
  sent: { label: "La participant", tone: "warn" },
  participant_signed: { label: "La FPED", tone: "warn" },
  completed: { label: "Semnat", tone: "ok" },
  rejected: { label: "Refuzat", tone: "bad" },
  canceled: { label: "Anulat", tone: "neutral" },
};

export function shortStatus(status) {
  return SHORT_STATUS[status] || { label: status || "—", tone: "neutral" };
}

/** Something on this row needs a person: shown as a warning next to it. */
export function rowAttention(row) {
  if (!row) return null;
  if (row.withdrawal_error) return "Participantul s-a retras, dar anularea la eSemneaza nu a mers; se reîncearcă automat";
  if (row.status === "send_failed") return "Trimiterea a eșuat";
  if (row.status === "participant_signed" && row.fped_sign_error) return "Semnătura FPED a eșuat";
  if (row.status === "completed" && !row.archived_at) return "Semnat, dar nearhivat";
  if (row.status === "rejected") return row.rejection_reason ? `Refuzat: „${row.rejection_reason}”` : "Refuzat";
  return null;
}

/** A file name without diacritics or spaces: "Grupă pentru limbi" → "Grupa_pentru_limbi". */
export function ascii(name) {
  const folded = String(name || "").normalize("NFKD").replace(/[\u0300-\u036f]/g, "");
  return folded.replace(/[^A-Za-z0-9._-]+/g, "_").replace(/^[._]+|[._]+$/g, "") || "export";
}

/** Filters → query params, leaving out what is empty. */
export function registerParams(f = {}) {
  const p = {};
  if (f.status) p.status = f.status;
  if (f.group_id) p.group_id = f.group_id;
  if (f.year) p.year = f.year;
  if (f.sent_from) p.sent_from = f.sent_from;
  if (f.sent_to) p.sent_to = f.sent_to;
  if (f.q && f.q.trim()) p.q = f.q.trim();
  if (f.probes) p.probes = true;
  // acreditat | fped — which contract text (13.10.2026).
  if (f.regime) p.regime = f.regime;
  return p;
}

export function hasFilters(f = {}) {
  const { probes, ...rest } = registerParams(f);
  return Object.keys(rest).length > 0;
}
